// MobileDPad - Touch controls for mobile gameplay
import { memo } from 'react';

const MobileDPad = memo(({ keysPressed, setIsMoving, setDirection }) => {
  const handleTouchStart = (key, dir) => (e) => {
    e.preventDefault();
    keysPressed.current.add(key);
    setIsMoving(true);
    setDirection(dir);
  };

  const handleTouchEnd = (key) => (e) => {
    e.preventDefault();
    keysPressed.current.delete(key);
    if (keysPressed.current.size === 0) setIsMoving(false);
  };

  const handleTouchCancel = (key) => (e) => {
    keysPressed.current.delete(key);
    if (keysPressed.current.size === 0) setIsMoving(false);
  };

  const btnClass = "bg-white/95 backdrop-blur-sm rounded-xl flex items-center justify-center active:bg-mint-green active:text-white border-2 border-mint-green shadow-md select-none";
  const btnStyle = { minHeight: 40, touchAction: 'none' };

  return (
    <div className="absolute bottom-32 md:bottom-48 right-2 z-[260] xl:hidden" data-testid="mobile-dpad">
      <div className="grid grid-cols-3 gap-1.5" style={{ width: 130, height: 130 }}>
        <div />
        <button
          onTouchStart={handleTouchStart('w', 'up')}
          onTouchEnd={handleTouchEnd('w')}
          onTouchCancel={handleTouchCancel('w')}
          className={btnClass}
          style={btnStyle}
          data-testid="dpad-up"
        >
          <span className="text-2xl font-bold text-mint-green pointer-events-none">&#9650;</span>
        </button>
        <div />
        <button
          onTouchStart={handleTouchStart('a', 'left')}
          onTouchEnd={handleTouchEnd('a')}
          onTouchCancel={handleTouchCancel('a')}
          className={btnClass}
          style={btnStyle}
          data-testid="dpad-left"
        >
          <span className="text-2xl font-bold text-mint-green pointer-events-none">&#9664;</span>
        </button>
        <div className="bg-mint-green/30 rounded-xl border-2 border-mint-green/50" />
        <button
          onTouchStart={handleTouchStart('d', 'right')}
          onTouchEnd={handleTouchEnd('d')}
          onTouchCancel={handleTouchCancel('d')}
          className={btnClass}
          style={btnStyle}
          data-testid="dpad-right"
        >
          <span className="text-2xl font-bold text-mint-green pointer-events-none">&#9654;</span>
        </button>
        <div />
        <button
          onTouchStart={handleTouchStart('s', 'down')}
          onTouchEnd={handleTouchEnd('s')}
          onTouchCancel={handleTouchCancel('s')}
          className={btnClass}
          style={btnStyle}
          data-testid="dpad-down"
        >
          <span className="text-2xl font-bold text-mint-green pointer-events-none">&#9660;</span>
        </button>
        <div />
      </div>
    </div>
  );
});

export default MobileDPad;
